import React, { useEffect, useState } from 'react'

export const OnlineStatusHandler: React.FC = () => {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine)

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true)
      // Refresh the page when coming back online
      window.location.reload()
    }

    const handleOffline = () => {
      setIsOnline(false)
    }

    // Add event listeners
    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    // Cleanup event listeners
    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  return (
    <div className="fixed bottom-4 right-4">
      {!isOnline && <div className="rounded-md bg-red-500 px-4 py-2 text-white">You are currently offline.</div>}
    </div>
  )
}

export default OnlineStatusHandler
